import {
  ApiPaginationParams,
  ApiQueryParams,
  IncludeApiQueryParam,
  ISortingParams,
} from '@/types/api';
import {
  ApiIndividualPayment,
  ApiPaginatedPayments,
  ApiPayPayments,
  PaymentPayMethod,
} from '@/types/payment';
import qs from 'query-string';
import { ApiService } from './api';

export class PaymentService extends ApiService {
  static PATH = '/payments';

  static async getPayments(
    filters: ApiQueryParams = {},
    pagination: ApiPaginationParams = {},
    include?: IncludeApiQueryParam,
    sort?: ISortingParams,
  ): Promise<ApiPaginatedPayments> {
    const queryString = qs.stringify({
      ...filters,
      ...pagination,
      include,
      ...(sort && {
        sort: Object.entries(sort).reduce(
          (acc: string[], [fieldName, sort]) => {
            return [...acc, `${fieldName}[${sort}]`];
          },
          [],
        ),
      }),
    });
    return ApiService.get(`${this.PATH}?${queryString}`);
  }

  static async getPayment(
    id: string,
    include?: IncludeApiQueryParam,
  ): Promise<ApiIndividualPayment> {
    const queryString = qs.stringify({ include });
    return ApiService.get(
      `${this.PATH}/${id}${queryString ? `?${queryString}` : ''}`,
    );
  }

  static async pay(data: {
    paymentIds: string[];
    paymentMethod: PaymentPayMethod;
  }): Promise<ApiPayPayments> {
    return ApiService.post(`${this.PATH}/pay`, data);
  }
}
